(function () {
    let tlCartGoalEmbedClone;

    const GREEN = "#0C1B3C";
    const style = document.createElement("style");
    style.id = "tl-kit-rewards-style";
    style.textContent = `
        cart-drawer .drawer__content { overflow-y: auto; overflow-x: hidden; }
        cart-drawer .drawer__header { display: contents; }
        cart-drawer .drawer__content > * { flex-shrink: 0; }
        cart-drawer .drawer__body { overflow: visible; flex: 0 0 auto; }
        cart-drawer .cart-drawer__header { position: sticky; top: 0; z-index: 3; background: rgb(var(--color-background, 250,249,246)); }
        cart-drawer .cart-drawer__footer { position: sticky; bottom: 0; z-index: 3; margin-top: auto; background: rgb(var(--color-background, 250,249,246)); }

        .tl-custom-cart-goal-container { padding: 0 30px; }
        .tl__cart-goal__container__drawer { border: 0 !important; border-radius: 0 !important; padding: 8px 0 0 !important; margin: 0 0 8px !important; background: transparent !important; display: block !important; text-align: center; }
        .tl__cart-goal__container__drawer::before { content: "YOUR KIT REWARDS"; display: block; font: 700 12px/1 "Helvetica Neue", Helvetica, Arial, sans-serif; letter-spacing: 1.5px; margin-bottom: 14px; }
        .tl__cart-goal__reward-description__drawer { margin: 0 0 8px !important; font-size: 14px !important; line-height: 1.4 !important; font-weight: 400 !important; letter-spacing: 0 !important; width: 100% !important; max-width: none !important; text-align: center !important; }
        .tl-kit-unlocked { display: block; font-weight: 700; color: inherit; margin-bottom: 2px; }
        .tl-kit-unlocked::before { content: "\\2713"; display: inline-block; width: 16px; height: 16px; margin-right: 6px; border-radius: 50%; background: ${GREEN}; color: #fff; font-size: 11px; line-height: 16px; text-align: center; vertical-align: 1px; }
        .tl__cart-goal__goal-container__drawer { margin: 58px 0 60px 0 !important; height: 8px !important; border-radius: 15px !important; background: #d9d9d9 !important; }
        .tl__cart-goal__goal-process__drawer { height: 8px !important; border-radius: 15px !important; background-image: linear-gradient(-45deg, rgba(255,255,255,.35) 25%, transparent 25%, transparent 50%, rgba(255,255,255,.35) 50%, rgba(255,255,255,.35) 75%, transparent 75%) !important; background-color: ${GREEN} !important; background-size: 16px 16px !important; background-repeat: repeat !important; animation: tlStripeMove 1s linear infinite; transition: width 0.8s ease-in-out !important; }
        @keyframes tlStripeMove { 0% { background-position: 0 0; } 100% { background-position: 16px 0; } }
        .tl__cart-goal__goal-check-point__drawer { width: 48px !important; height: 48px !important; overflow: visible !important; }
        .tl__cart-goal__goal-check-point__drawer .pcirc { width: 48px !important; height: 48px !important; border: 3px solid #d9d9d9 !important; background: #fff !important; overflow: visible !important; box-sizing: border-box; padding: 3px; }
        .tl__cart-goal__goal-check-point__drawer .pcirc img { filter: grayscale(1); opacity: .7; inset: 3px !important; width: calc(100% - 6px) !important; height: calc(100% - 6px) !important; }
        .tl__cart-goal__goal-check-point__drawer.is-reached .pcirc { border-color: ${GREEN} !important; }
        .tl__cart-goal__goal-check-point__drawer.is-reached .pcirc img { filter: none; opacity: 1; }
        .tl__cart-goal__goal-check-point__drawer.is-reached .pcirc::after { content: "\\2713"; position: absolute; top: -7px; left: -7px; width: 20px; height: 20px; border-radius: 50%; background: ${GREEN}; border: 2px solid #fff; box-sizing: border-box; color: #fff; font-size: 11px; font-weight: 700; line-height: 16px; text-align: center; z-index: 5; }
        .tl__cart-goal__goal-check-point-value { opacity: 1 !important; visibility: visible !important; top: -24px !important; left: 50% !important; transform: translateX(-50%); width: auto !important; white-space: nowrap; font: 700 12px/1 "Helvetica Neue", Helvetica, Arial, sans-serif !important; letter-spacing: 0 !important; }
        .tl__cart-goal__goal-check-point-title { opacity: 1 !important; visibility: visible !important; top: 54px !important; left: 50% !important; transform: translateX(-50%); width: 84px !important; text-align: center; font: 600 11px/1.2 "Helvetica Neue", Helvetica, Arial, sans-serif !important; letter-spacing: 0 !important; text-transform: none !important; }
        .tl__cart-goal__goal-check-point__drawer.is-reached .tl__cart-goal__goal-check-point-title { color: ${GREEN} !important; }
        .tl__cart-goal__goal-check-point__drawer.is-target .tl__cart-goal__goal-check-point-title { color: #1b2a5c !important; }
        .tl__cart-goal__goal-check-point__drawer.is-target .pcirc { border-color: #1b2a5c !important; }
        .tl__cart-goal__goal-check-point__drawer.is-target .pcirc img { filter: none; opacity: 1; }
        .tl__cart-goal__container__drawer [class*="tl__cart-goal__free-gift-container"] { display: none !important; }
        @media (max-width: 480px) {
            .tl-custom-cart-goal-container { padding: 0 16px; }
            .tl__cart-goal__goal-check-point-title { width: 66px !important; font-size: 10px !important; line-height: 1.2 !important; overflow-wrap: anywhere; }
            .tl__cart-goal__goal-check-point-value { font-size: 11px !important; }
        }
    `;
    const mount = () => {
        const host = document.head || document.documentElement;
        if (host) host.appendChild(style);
        else document.addEventListener("DOMContentLoaded", mount, { once: true });
    };
    mount();

    Object.defineProperty(window, "tlCartGoalEmbed", {
        get() {
            return tlCartGoalEmbedClone;
        },
        set(value) {
            if (value && !tlCartGoalEmbedClone) {

                value.formatQuantity = (n) => `${n} ${Number(n) === 1 ? "Kit" : "Kits"}`;

                const originalGetLeftAmountText = value.getLeftAmountText;
                value.getLeftAmountText = function() {
                    let baseText = originalGetLeftAmountText ? originalGetLeftAmountText.apply(this) : "";
                    let lastReachedMilestone = null;
                    if (this.milestones) {
                        for (let i = 0; i < this.milestones.length; i++) {
                            if (this.cartTotal >= this.milestones[i].cart_value) {
                                lastReachedMilestone = this.milestones[i];
                            }
                        }
                    }
                    if (lastReachedMilestone && this.cartTotal < this.milestones[this.milestones.length - 1].cart_value) {
                        return `<span class="tl-kit-unlocked">${lastReachedMilestone.title} unlocked!</span>` + baseText;
                    }
                    return baseText;
                };

                let lastBarWidth = "";
                const applyCustomTitles = () => {
                    if (!value || !value.milestones) return;

                    const widgets = document.querySelectorAll(".tl__cart-goal__goal-container, .tl__cart-goal__goal-container__drawer");
                    widgets.forEach(widget => {
                        const descElements = widget.querySelectorAll(".tl__cart-goal__reward-description__drawer");
                        let lastReached = null;
                        for (let i = 0; i < value.milestones.length; i++) {
                            if (value.cartTotal >= value.milestones[i].cart_value) {
                                lastReached = value.milestones[i];
                            }
                        }

                        descElements.forEach(descEl => {
                            if (lastReached && !descEl.innerHTML.includes("unlocked!") && value.cartTotal < value.milestones[value.milestones.length - 1].cart_value) {
                                descEl.innerHTML = `<span class="tl-kit-unlocked">${lastReached.title} unlocked!</span>` + descEl.innerHTML;
                            }
                        });

                        const ms = value.milestones;
                        const n = ms.length;
                        const pos = (i) => ((i + 0.5) / n) * 100;
                        widget.querySelectorAll(".tl__cart-goal__goal-check-point__drawer").forEach((node, i) => {
                            node.style.setProperty("margin-left", pos(i % n) + "%", "important");
                        });

                        const bar = widget.querySelector(".tl__cart-goal__goal-process__drawer");
                        if (bar) {
                            const c = value.cartTotal;
                            let fill = 100;
                            if (c < ms[n - 1].cart_value) {
                                let k = -1;
                                for (let i = 0; i < n; i++) if (c >= ms[i].cart_value) k = i;
                                const a = k < 0 ? 0 : pos(k);
                                const aVal = k < 0 ? 0 : ms[k].cart_value;
                                const b = pos(k + 1);
                                const bVal = ms[k + 1].cart_value;
                                fill = a + ((c - aVal) / (bVal - aVal)) * (b - a);
                            }
                            const target = fill + "%";
                            if (lastBarWidth && lastBarWidth !== target && !bar.dataset.tlAnim) {
                                bar.dataset.tlAnim = "1";
                                bar.style.width = lastBarWidth;
                                void bar.offsetWidth;
                            }
                            bar.style.width = target;
                            lastBarWidth = target;
                        }

                        const titleElements = widget.querySelectorAll(".tl__cart-goal__goal-check-point-title");
                        if (!titleElements.length) return;

                        let closestPoint = -1;
                        for (let i = 0; i < value.milestones.length; i++) {
                            if (closestPoint === -1 && value.milestones[i].cart_value > value.cartTotal) {
                                closestPoint = i;
                            }
                        }

                        titleElements.forEach((el, index) => {
                            const milestoneIndex = index % value.milestones.length;
                            const milestone = value.milestones[milestoneIndex];
                            const isReached = value.cartTotal >= milestone.cart_value;
                            const isNext = closestPoint === milestoneIndex;

                            let text = milestone.title;
                            let color = "inherit";

                            if (isReached) {
                                text = "Unlocked";
                                color = "var(--tl__cart-goal__filled-bar-color, inherit)";
                            } else if (isNext) {
                                text = "Next reward";
                                color = "inherit";
                            } else {
                                text = milestone.title;
                                color = "inherit";
                            }

                            if (el.innerHTML !== text) {
                                el.innerHTML = text;
                                el.style.color = color;
                                el.style.fontWeight = "600";
                            }
                        });
                    });
                };

                const observer = new MutationObserver(() => {
                    applyCustomTitles();
                });
                observer.observe(document.body, { childList: true, subtree: true });

                const wrapMethod = (methodName) => {
                    const original = value[methodName];
                    if (typeof original === "function") {
                        value[methodName] = function(...args) {
                            const res = original.apply(this, args);
                            setTimeout(applyCustomTitles, 0);
                            return res;
                        };
                    }
                };

                wrapMethod("updateCartGoal");
                wrapMethod("updateAllCartGoals");
                wrapMethod("renderAllCartGoals");


                value.replaceVariables = (string, milestone) => {
                    const cartValue = milestone.cart_value;
                    return string
                        .replace(/{{discount}}/g, `${cartValue} 
                            ${
                                milestone.discount_type === "percentage" ?
                                    `${cartValue}%` :
                                    window.tlCartGoalEmbed.formatMoney(cartValue * 100, window.tlCartGoalEmbed.currencyFormat, window.tlCartGoalEmbed.currencyDisplay)
                            }`  
                        )
                        .replace(/{{amount}}/g, window.tlCartGoalEmbed.formatMoney((cartValue - window.tlCartGoalEmbed.cartTotal) * 100, window.tlCartGoalEmbed.currencyFormat, window.tlCartGoalEmbed.currencyDisplay))
                        .replace(/{{title}}/g, `<strong class="font-bold">${milestone.title}</strong>`)
                }

            }

            tlCartGoalEmbedClone = value;
        },
        configurable: true,
    });
})();

